import { FETCH_ORDERS } from './constants'

import { failure, success, status } from '@utils/redux'

const initialState = {
  data: {},
  status: status.PRISTINE,
  error: {}
}

const orders = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDERS:
      return {
        ...state,
        status: status.FETCHING
      }
    case failure(FETCH_ORDERS):
      return {
        ...state,
        status: status.ERROR,
        error: action.error
      }
    case success(FETCH_ORDERS):
      return {
        ...state,
        status: status.LOADED,
        error: false,
        data: action.payload.data
      }
    default:
      return state
  }
}

export default orders
